// Base
import * as Sentry from "@sentry/react";

interface CaptureExceptionOptions {
  tags?: Record<string, string>;
  extra?: Record<string, any>;
  contexts?: Record<string, any>;
  beforeCapture?: (scope: Sentry.Scope) => void;
}

const captureException = (
  error: unknown,
  options: CaptureExceptionOptions = {},
) => {
  const { tags = {}, extra = {}, contexts = {}, beforeCapture } = options;

  Sentry.withScope((scope) => {
    Object.entries(tags).forEach(([key, value]) => {
      scope.setTag(key, value);
    });

    Object.entries(extra).forEach(([key, value]) => {
      scope.setExtra(key, value);
    });

    Object.entries(contexts).forEach(([name, contextData]) => {
      scope.setContext(name, contextData);
    });

    if (typeof beforeCapture === "function") {
      beforeCapture(scope);
    }

    Sentry.captureException(error);
  });
};

export default captureException;
